import {
    getSortedListRequest,
    getSearchListCountRequest,
} from '../../../../services/network/search/sort';

class CommonSortedListService {
    async getSortedList(values) {
        return await getSortedListRequest(values);
    }

    async getSearchListCount(values) {
        return await getSearchListCountRequest(values);
    }
}

export const SortedListService = new CommonSortedListService();
